import { Box, Button } from '@mui/material'
import React from 'react'
import { exportKiddomTreeToGoogleDriveFolder } from './utilities'
import { INode } from 'shared/types/tree'

type Progress = {
  pct: number
  total?: number
  done?: number
}

export function Export({
  tree,
  accessToken,
}: {
  tree: INode
  accessToken: string
}) {
  const [progress, setProgress] = React.useState<Progress>({
    pct: 0,
    total: undefined,
    done: undefined,
  })
  const [exporting, setExporting] = React.useState(false)
  const [exportedFolderId, setExportedFolderId] = React.useState<string>()
  const [error, setError] = React.useState<string>()

  return (
    <Box>
      Export Kiddom Tree to Google Drive:
      <Button
        disabled={exporting}
        onClick={() => {
          setExporting(true)
          exportKiddomTreeToGoogleDriveFolder(
            tree,
            accessToken,
            (pct, total, done) => setProgress({ pct, total, done }),
          )
            .then((folderId) => {
              setExportedFolderId(folderId)
              setExporting(false)
            })
            .catch((e) => {
              console.error(e)
              setError('Error exporting tree to Google Drive')
            })
        }}
      >
        {exporting ? 'Exporting...' : 'Export'}
      </Button>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <progress style={{ flexGrow: '1' }} value={progress.pct} />
        {progress.done && (
          <span style={{ width: '10rem', textAlign: 'right' }}>
            ({progress.done.toLocaleString()}
            {' / '}
            {(progress.total ?? 0).toLocaleString()})
          </span>
        )}
      </div>
      {exportedFolderId && (
        <Box>
          Exported to:{' '}
          <a
            href={`https://drive.google.com/drive/folders/${exportedFolderId}`}
            target="_blank"
          >
            https://drive.google.com/drive/folders/{exportedFolderId}
          </a>
        </Box>
      )}
      {error && <Box>{error}</Box>}
    </Box>
  )
}
